<template>
  <div class="input-container"
       @click="focusInput"
       :class="[info?.type || 'text',
       {'focused' : focused }]">
  <textarea :type="info?.type || 'text'"
            :maxlength="maxText"
         autocomplete="on"
         @focus="focused = true"
         @blur="focused = false"
         :name="info?.dataIndex || 'value'"
         :placeholder="info?.placeholder || '-'"
         v-model="textInput"/>
    <div class="counter-container">
      {{ lengthText }}/{{ maxText }}
    </div>
  </div>
</template>

<script>

export default {
  name: "TextareaMain",
  props: {
    maxText: {
      type: Number,
      default: 500
    },
    alert: {
      type: Boolean,
      default: false
    },
    info: {
      type: Object,
      required: true
    },
    nameBlock: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      textInput: '',
      focused: false
    }
  },
  computed: {
    lengthText() {
      return this.textInput.length;
    }
  },
  watch: {
    focused() {
      this.$emit('focusInput', this.focused)
    },
    textInput() {
      this.$emit('changeTextInput', this.textInput, this.info.dataIndex)
    },
  },
  methods: {
    focusInput() {
      let block = document.querySelector("." + this.nameBlock)
      let input = block.querySelectorAll("textarea")
      input[this.info.id].focus()
    },
  }
}
</script>

<style scoped lang="scss">


.input-container {
  font-family: 'Verdana', sans-serif;
  width: 100%;
  overflow: visible;
  cursor: text;
  display: flex;
  justify-content: center;
  align-items: center;
  background: unset;
  position: relative;
  transition: all .5s ease;
  height: 0;
  background: rgba(var(--color-light-purple-grey-rgba), .1);
  border-color: rgba(var(--color-dark-purple-grey-rgba), .1);
  border-style: solid;

  &:hover {
    border-color: rgba(var(--color-dark-purple-grey-rgba), .8);
  }
  &.focused {
    border-color: rgba(var(--color-dark-purple-grey-rgba), .8);
  }

  .counter-container {
    color: var(--color-light-purple-grey);
    position: absolute;
  }

  & textarea {
    resize: none;
    font-family: 'Verdana', sans-serif;
    width: 100%;
    overflow: visible;
    height: 100%;
    color: var(--color-light-purple-grey) !important;
    background-color: rgba(1,1,1,0) !important;

    &::placeholder {
      font-family: 'Verdana', sans-serif;
      color: var(--color-light-purple-grey);
    }

    &::-webkit-scrollbar {
      display: none;
    }
  }
}

@media (max-width: 3024px){
  .input-container {
    border-width: 1px;
    min-height: 190px;
    border-radius: 12px;
    padding: 16px 22px;
    & textarea {
      font-size: 22px;
    }
    .counter-container {
      font-size: 22px;
      bottom: 16px;
      right: 22px;
    }
  }
}


@media (max-width: 1920px) {
  .input-container {
    min-height: 158px;
    border-radius: 10px;
    padding: 12px 18px;
    & textarea {
      font-size: 22px;
    }
    .counter-container {
      font-size: 18px;
      bottom: 12px;
      right: 18px;
    }
  }
}


@media (max-width: 1600px) {
  .input-container {
    min-height: 122px;
    border-radius: 8px;
    padding: 8px 14px;
    & textarea {
      font-size: 14px;
    }
    .counter-container {
      font-size: 14px;
      bottom: 8px;
      right: 14px;
    }
  }
}
@media (max-height: 800px) {
  .input-container {
    min-height: 122px;
    border-radius: 6px;
    padding: 6px 10px;
    & textarea {
      font-size: 12px;
    }
    .counter-container {
      font-size: 14px;
      bottom: 6px;
      right: 10px;
    }
  }
}

@media (max-width: 1400px) and (min-height: 801px) {
  .input-container {
    min-height: 122px;
    border-radius: 8px;
    padding: 8px 14px;
    & textarea {
      font-size: 14px;
    }
    .counter-container {
      font-size: 14px;
      bottom: 8px;
      right: 14px;
    }
  }
}

@media (max-width: 1133px) {
  .input-container {
    min-height: 122px;
    border-radius: 6px;
    padding: 6px 10px;
    & textarea {
      font-size: 12px;
    }
    .counter-container {
      font-size: 14px;
      bottom: 6px;
      right: 10px;
    }
  }
}
@media (max-width: 769px) {
  .input-container {
    min-height: auto;
    height: 100%;
    border-radius: 6px;
    padding: 6px 10px;
    & input {
      font-size: 12px;
    }
    .counter-container {
      font-size: 12px;
      bottom: 6px;
      right: 10px;
    }
  }
}

@media (min-width: 3025px) {
  .input-container {
    min-height: 280px;
    border-radius: 14px;
    padding: 20px 24px;
    & textarea {
      font-size: 32px;
    }
    .counter-container {
      font-size: 32px;
      bottom: 20px;
      right: 24px;
    }
  }
}



</style>

